import MsgBox from './MsgBox'

export default MsgBox
